import { useContext } from "react";
import { ThemeContext } from "../../context/ThemeContext";
import "./themeToggle.css";

const ThemeToggle = () => {
  const { theme, toggleTheme } = useContext(ThemeContext);

  return (
    <div className="theme-toggle" onClick={toggleTheme}>
      <span className={theme === "ivory" ? "active" : ""}>☀</span>
      <div className="toggle-thumb" />
      <span className={theme === "royal-black" ? "active" : ""}>🌙</span>
    </div>
  );
};

export default ThemeToggle;
